var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "28px",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 32 32",
    width: "28px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_Square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0H2C0.895,0,0,0.895,0,2v28c0,1.105,0.895,2,2,2h28c1.104,0,2-0.895,2-2V2C32,0.895,31.104,0,30,0z    M30,30H2V2h28V30z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.271,22.707c0.394,0.39,1.034,0.39,1.429,0l5.324-5.28l5.276,5.276c0.394,0.395,1.034,0.395,1.428,0   c0.394-0.395,0.394-1.037,0-1.432l-5.268-5.269l5.238-5.195c0.394-0.391,0.394-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0   l-5.231,5.188l-5.309-5.31c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l5.301,5.302l-5.331,5.287   C8.877,21.683,8.877,22.317,9.271,22.707z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ac6fc03bd2cf849375276e4c31e99199.svg";
export { ForwardRef as ReactComponent };